import React from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './AdminStatus.styles';

type TripStatusProps = {
  status: string;
  style?: any;
};

const AdminStatus: React.FC<TripStatusProps> = ({ status, style }) => {
  return (
    <p style={style} className={status?.toLowerCase()}>
      <FormattedMessage
        id={`fleetadmin.admins.info.${status?.toLowerCase()}`}
      />
      <style jsx>{styles}</style>
    </p>
  );
};

export default AdminStatus;
